import React, { useRef, useEffect } from "react";
import {
    Box,
    useTheme,
    useMediaQuery,
    alpha,

} from '@material-ui/core';

import { useMeasure } from "react-use";
import { useImage } from '../../../utils/hooks';
import { useCalculator } from '../../../state/calculatorState';
import { resizeCanvas, ordinal } from '../../../utils/utils';
import { isUndefined } from '../../../core/calculatorUtils';
import { DARK_MODE } from '../../../state/themeState';
import marker_white from '../../../assets/marker2_white.png';
import marker_grey from '../../../assets/marker2_grey.png';
import { data } from '../../../data/PercentileRange'


export const SummaryPercentileBand = () => {
    const [, darkIcon] = useImage(marker_white)
    const [, lightIcon] = useImage(marker_grey)
    const ref = useRef();
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('xs'));
    // const summaryData = useContext(SummaryContext);

    //income
    let [{ income },] = useCalculator();


    let icon = (theme.palette.type === DARK_MODE) ? darkIcon : lightIcon;
    if (!icon) icon = null;

    const [refContainer, { width }] = useMeasure();

    useEffect(() => {
        if (width === 0) return
        let canvas = ref.current;
        let context = canvas.getContext('2d');
        const { ratio } = resizeCanvas(canvas, context, 120);

        const salary = income.a;
        let percentile = 0;

        const currentYearData = data[0].data
        if( isUndefined(currentYearData)) return

        for (let i = 0; i <currentYearData.length; i++) {
            const from =currentYearData[i].income.from;
            const to =currentYearData[i].income.to === 0 ? salary + 1 :currentYearData[i].income.to
            if (salary >= from && salary <= to) {
                percentile =currentYearData[i].percentile;
                break;
            }
        }

        draw(context, canvas, theme, ratio, percentile, icon);
    });


    let height = 110;
    if (small) height = 90;
    const padding = small ? 20 : 10;



    return (
        <Box style={{ paddingTop: padding, paddingBottom: 20 }}>
            <Box display="flex" flexGrow={1} style={{ height: `${height}px`, width: '100%' }} ref={refContainer}>
                <canvas ref={ref}  height={`${height}px`} />
            </Box>
            
        </Box>
    );

}



const draw = (ctx, canvas, theme, ratio, percentile, icon) => {

    let margin = 12.5 * ratio;
    let barWidth = (canvas.width / 1) - (2 * margin);
    let barHeight = 30 * ratio;
    let barY = margin * 5;
    let barX = margin;
    let labelY = margin * 3.0;


    const shadowColor = alpha(theme.palette.grey[900], 0.1)
    const barColor = theme.palette.primary.main
    const bgColor = alpha(theme.palette.primary.dark, 0.25)

    // shadow
    ctx.beginPath();
    ctx.rect(barX - 1, barY - 1, barWidth + 4, barHeight + 4);
    ctx.fillStyle = shadowColor;
    ctx.fill();

    // bg
    ctx.beginPath();
    // ctx.rect(x1, y1, x2, y2);
    ctx.rect(barX, barY, barWidth, barHeight);
    ctx.fillStyle = bgColor;
    ctx.fill();


    let percentilePos = (barWidth / 100) * percentile;

    // percentile
    var grd = ctx.createLinearGradient(0, 0, barWidth, 0);
    grd.addColorStop(0, theme.palette.primary.dark);
    grd.addColorStop(0.5, theme.palette.primary.main);
    grd.addColorStop(1, theme.palette.primary.light);

    ctx.beginPath();
    ctx.rect(barX, barY, percentilePos, barHeight);
    ctx.fillStyle = grd //`${barColor}`
    ctx.fill();


    if(icon){
        let px = percentilePos
        px += 7 * ratio;
        ctx.drawImage(icon, px, barY + barHeight*1, 12.5*ratio, 30*ratio);
    }


    let labelXPos = percentile < 50 ? percentilePos + margin + (5 * ratio) : percentilePos + (5 * ratio)
    let labelAlign = percentile < 50 ? "left" : "right"

    let labelYpos = labelY;

    ctx.font = `${theme.typography.body1.fontSize * ratio * 0.85}px ${theme.typography.body1.fontFamily[0]}`;
    ctx.fillStyle = `${theme.palette.text.primary}`;
    ctx.textAlign = labelAlign
    ctx.fillText(`${percentile}${ordinal(percentile)} percentile`, labelXPos, labelYpos - (2.5 * ratio));


    ctx.font = `${theme.typography.body1.fontSize * ratio * 0.75}px ${theme.typography.body1.fontFamily[0]}`;
    ctx.fillStyle = `${barColor}`;
    ctx.textAlign = labelAlign
    ctx.fillText(`You're in the ${percentile}% income band`, labelXPos, labelYpos + (12 * ratio));


    ctx.beginPath();
    ctx.rect(percentilePos + margin, barY - barHeight * 1, 1, barHeight * 2);
    ctx.fillStyle = `${theme.palette.text.primary}`;
    ctx.fill();



    for (let i = 1; i < percentile; i++) {
        let px = (barWidth / 100) * i;

        let colour = i % 5 === 0 ? alpha(theme.palette.text.primary, 0.25) : alpha(theme.palette.text.primary, 0.1)

        ctx.beginPath();
        ctx.rect(px + margin, barY, 1, barHeight);
        ctx.fillStyle = colour
        ctx.fill();
    }



    ctx.font = `${theme.typography.h2.fontSize * ratio}px ${theme.typography.h2.fontFamily[0]}`;
    ctx.fillStyle = `${theme.palette.text.primary}`;
    ctx.textAlign = "center";
    ctx.fillText(`Income Range`, margin + barWidth * 0.5, margin + 0);
}

export default SummaryPercentileBand;